import API from 'services/API';

export function getBankAccounts(filters, cancellable) {
  return API.request(
    {
      method: 'POST',
      url: '/taxpayer/russianBankAccounts',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: filters,
      isKeepCache: true,
    },
    cancellable,
  );
}

export function getBankAccountsExcel(sort) {
  return API.request({
    method: 'POST',
    url: '/taxpayer/russianBankAccounts/excel',
    data: { sort },
    responseType: 'arraybuffer',
  });
}
